export enum CodeInputState {
  Phone,
  Email,
}
